export const equipmentOffice = [
  {
    name: 'equipment_office_info',
    value: '',
    type: 'textarea',
    placeholder: 'INFO',
    className: 'mt-2'
  }
];
